// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#scattered-images-canvas[data-v-987a974c]{height:100vh;width:100vw;bottom:0;position:fixed;top:0;right:0;left:0}#scattered-images-canvas .image[data-v-987a974c]{position:absolute;z-index:2}#scattered-images-canvas .image svg *[data-v-987a974c]{fill:#fae9e1}", ""]);
// Exports
module.exports = exports;
